import {Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdminMenuService, MenuModule} from "@app/pages/admin-panel/admin-menu.service";
import {MenuSectionComponent} from "@app/pages/admin-panel/menu-section/menu-section.component";
import {AdminContextService} from "@app/security/admin-context.service";
import {MaterialModule} from "@ui-webkit/modules/material.module";

// todo group the menu items
@Component({
  selector: 'app-menu-module',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    MenuSectionComponent
  ],
  styleUrls: ['./menu-module.component.scss'],
  template: `
    <mat-accordion [multi]="true" class="full-width" displayMode="flat">
      @for (module of modules; track module; let i = $index) {
        <!-- One group header per restriction-level run: consecutive GLOBAL modules
             (Feature Config, Internal Access) share a single GLOBAL heading. -->
        @if (isNewGroup(i)) {
          <mat-divider *ngIf="i > 0"></mat-divider>
          <div class="pt-20 pl-20 mat-primary text-uppercase"
               [ngClass]="getMenuLabel(module) === 'GLOBAL' ? 'menu-label-global' : 'menu-label-contextual'">
            {{ getMenuLabel(module) }}
          </div>
        }

        @if (isGlobal(module)) {
          <mat-expansion-panel [expanded]="true" class="menu-module-expansion-panel mat-elevation-z0">
            <mat-expansion-panel-header>{{ module.label }}</mat-expansion-panel-header>
            <div class="fx-col-w-100">
              @for (section of module.sections; track section) {
                <app-menu-section [section]="section" class="full-width"></app-menu-section>
              }
            </div>
          </mat-expansion-panel>
        } @else {
          <!-- Contextual (LANDLORD/LOCATION/OFFERING): the entity-name caption above
               heads the sections directly — no redundant module-label sub-heading.
               Sections render as cascading expansion panels (see app-menu-section),
               aligned at the accordion edge to match the GLOBAL menu. -->
          <div class="fx-col-w-100">
            @for (section of module.sections; track section) {
              <app-menu-section [section]="section" class="full-width"></app-menu-section>
            }
          </div>
        }
      }
    </mat-accordion>
  `
})
export class MenuModuleComponent implements OnInit {
  private _adminMenuService: AdminMenuService = inject(AdminMenuService);
  private _adminContext = inject(AdminContextService);

  modules: MenuModule[] = [];

  constructor() {
    this.modules = this._adminMenuService.getMenu()
      .filter(fl => fl.sections.length > 0);
  }

  ngOnInit(): void {
    this._adminContext.selectedAdminContextValueChanged$.subscribe((res) => {
      if (res) {
        this.modules = this._adminMenuService.getMenu()
          .filter(fl => fl.sections.length > 0);
      }
    });
  }

  get selectedLandlord() {
    return this._adminContext.selectedAdminContext.landlord
  }

  get selectedLocation() {
    return this._adminContext.selectedAdminContext.location;
  }

  get selectedOffering() {
    return this._adminContext.selectedAdminContext.offering;
  }

  isGlobal(module: MenuModule): boolean {
    return module.restrictionLevel === 'GLOBAL';
  }

  /**
   * True for the first module in a run of same-restriction-level modules, so the
   * group header (e.g. GLOBAL) is rendered once even when several modules share it.
   */
  isNewGroup(index: number): boolean {
    return index === 0
      || this.modules[index].restrictionLevel !== this.modules[index - 1].restrictionLevel;
  }

  getMenuLabel(module: MenuModule): string | null | undefined {
    switch (module.restrictionLevel) {
      case 'LANDLORD':
        return this.selectedLandlord?.name;
      case 'LOCATION':
        return this.selectedLocation?.name;
      case 'OFFERING':
        return this.selectedOffering?.name;
      case 'GLOBAL':
        return 'GLOBAL';
      default :
        return null;
    }
  }


}
